import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import Link from '@mui/material/Link';
import Divider from '@mui/material/Divider';

import MarloweDirections from 'components/Hotel/MarloweDirections.tsx';
import MarloweMap from 'components/Hotel/MarloweMap.tsx';
import MarloweGallery from 'components/Hotel/MarloweGallery.tsx';
import BookingLink from 'components/Hotel/BookingLink.tsx';

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

import hotelFailure from 'gallery/hotelFailure.png'

const amenityLink = "https://www.hotelmarlowe.com/boston-boutique-hotels/?&cm_mmc=WEB-_-KI-_-AMER-_-EN-_-EV-_-Google%20Business%20Profile-_-DD-_-marlowe";

export default function Accomodations() {
  return (
    <Box sx={{
      py: 3,
      px: {xs: 0, md: 3},
      alignSelf:"center",
      alignContent: "center",
      alignItems: "center",
      justifyContent: "center",
      display: 'flex',
    }}>
      <Card sx={{ 
          maxWidth: 800,
          width: "100%",
          backgroundColor: "#ffeedd",
          display: 'flex', 
          flexDirection: "column",
        }}>
        <CardHeader 
          title="Accomodations" 
          titleTypographyProps = {{variant: "h4"}}
          subheader="Kimpton Marlowe - Cambridge, MA"

          />
        <CardMedia
          sx={{ 
            width: "100%",
            objectFit: "contain",
          }}
          component="img"
          image="https://www.hotelmarlowe.com/images/1700-960/marlowe-hover-boston-kyle-klein-p1690134-77cb756f.jpg"
          title="Kimpton Marlowe"
        >
          
        </CardMedia>
        <CardContent id="info">
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
          We recommend staying at the nearby <Link href="https://www.hotelmarlowe.com/">Kimpton Marlowe hotel</Link>.
          <p />
          <p />
          
          <BookingLink linkText="PLEASE CLICK HERE TO BOOK AS PART OF OUR WEDDING"/>
          <p />
          NOTE: Amenity fee will be waived at check-in, rate discounts and upgrades apply only through the link
          <p />
          <Divider><Typography variant="h6" sx={(theme) => ({ fontWeight: '600',  color: theme.palette.grey[800] })}><ErrorOutlineIcon sx={{verticalAlign: "middle"}}/> IMPORTANT INFORMATION</Typography></Divider>
          <p />
        
          <Typography variant="body1" sx={{ fontWeight: '400', color: 'text.secondary' }}>
            <Card 
              variant='outlined'
              sx={{ 
                border: 0,
                backgroundColor: "#ffeedd",
                display: 'flex',
                flexDirection: {xs: "column", md: "row"}
              }}
            >
            <Box sx={{ py: 0, pl: 0, width: "100%", display: "flex", flexDirection: "column"}}>
              <CardContent sx={{ py: 0, pl: 0}}>
                Not seeing the rooms you want when you go to book with our link? Or did you book already without our 
                wedding link when you had an alert like  
                this <Typography sx={{display: {xs: "inline-block", md:"none"}}}>(see below)</Typography>
                <Typography sx={{display: {xs: "none", md:"inline-block"}}}>(see screenshot)</Typography> that
                the rate was no longer available? Maybe there isn't an option shown for a Queen Queen or a King room?
                <p />
                Never Fear! Court is here! You know he loves figuring out hotel stuff. Really.
                <p />
                Our contact at the hotel can manually add more room availability for all room types for our wedding block.
                <p />
                Reach out to Court directly via text or email
                {/* <ul>
                  <li><Link href='tel:+1XXX-XXX-XXX'>XXX-XXX-XXXX</Link></li>
                  <li><Link href='mailto: XXXXXXXXX@gmail.com'>XXXXXXXX@gmail.com</Link></li>
                </ul> */}
                <p />
              </CardContent>
            </Box>
            <CardMedia
              sx={{ 
                maxWidth: "400px",
                maxHeight: {xs: "100%", md: "600px"},
                objectFit: "contain",
                pb: 2,
              }}
              component="img"
              image={hotelFailure}
              title="Example Errors"
            />
          </Card>
          </Typography>
          <Divider />
          <p />
          Bookings with the Kimpton Marlowe provide complimentary amenities, including:
          <ul>
            <li>Daily wine hour at 5:00 PM</li>
            <li>GoPro rental</li>
            <li>Roll-away beds</li>
            <li>Concierge services</li>
            <li>Bicycles</li>
            <li><Link href={amenityLink}>And more</Link></li>
          </ul>
          </Typography>
          
          <MarloweGallery />

          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            <ul>
              <li>
              25 Edwin H Land Blvd, Cambridge, MA 02141
              </li>
            </ul>
          
          </Typography>

          <MarloweMap />
          <p/>
          <Divider />
          <p/>
          <Typography variant="h5" sx={{ color: 'text.secondary' }}>Directions to the venue</Typography>
          <p/>
          <MarloweDirections />
        </CardContent>
      </Card>
    </Box>
  );
}

